import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, Section } from '../../core';

@Component({
  selector: 'main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  @Input() sections: Array<Section> = [];
  @Output() closeMenu: EventEmitter<any> = new EventEmitter();

  username: string = null;

  constructor(public router: Router, public authService: AuthService) {}

  ngOnInit() {
    this.authService
      .getUserData()
      .subscribe(user => {
        this.username = user.name;
      })
    ;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
    this.closeMenu.emit(null);
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/layout/main-menu/main-menu.component.ts